'use client';
import { useState, useCallback, useEffect } from 'react';

const useDragAndDrop = (n)=>{
    let [l, i] = useState(false), [a, d] = useState(false), v = useCallback((e)=>{
        var r;
        e.preventDefault();
        let t = null === (r = n.current) || void 0 === r ? void 0 : r.querySelector('.swan-file-input');
        if (!t) return null;
        false === t.disabled && (i(true), !t.multiple && e.dataTransfer && e.dataTransfer.items.length > 1 && d(true));
    }, [
        n
    ]), u = useCallback((e)=>{
        e.preventDefault();
    }, []), s = useCallback((e)=>{
        var r;
        e.preventDefault();
        let t = null === (r = n.current) || void 0 === r ? void 0 : r.querySelector('.swan-file-input');
        if (!t) return null;
        false === t.disabled && (i(false), d(false));
    }, [
        n
    ]), f = useCallback((e)=>{
        var r, t;
        e.preventDefault();
        let l = null === (r = n.current) || void 0 === r ? void 0 : r.querySelector('.swan-file-input');
        if (!l) return null;
        if (false === l.disabled) {
            i(false), d(false);
            let r = null === (t = e.dataTransfer) || void 0 === t ? void 0 : t.files;
            if (!r || r.length <= 0) return;
            if (l.multiple) l.files = r;
            else {
                let e = r.item(0);
                if (!e) return;
                let t = new DataTransfer();
                t.items.add(e), l.files = t.files;
            }
            l.dispatchEvent(new Event('change', {
                bubbles: true
            }));
        }
    }, [
        n
    ]);
    return useEffect(()=>{
        let e = n.current;
        if (e) return e.addEventListener('dragover', v), e.addEventListener('dragenter', u), e.addEventListener('dragleave', s), e.addEventListener('drop', f), ()=>{
            e.removeEventListener('dragover', v), e.removeEventListener('dragenter', u), e.removeEventListener('dragleave', s), e.removeEventListener('drop', f);
        };
    }, [
        n,
        u,
        s,
        v,
        f
    ]), {
        isDragging: l,
        isMultiDropError: a
    };
};

export { useDragAndDrop };
